export interface FootnoteItemProps extends React.LiHTMLAttributes<HTMLLIElement> {
  text?: string;
}

const FootnoteItem = ({ text }: FootnoteItemProps) => {
  return <li>{text}</li>;
};

export default FootnoteItem;
